import React from "react";
import Dropdown from "../../FormFields/Dropdown";

const MessageA13 = (props) => {
  return <Dropdown {...props} />;
};

export default MessageA13;
